import { Badge, Group, Text } from '@mantine/core'
import { getCurrentDomain } from '@/utils/domain'

export const TestDomainIndicator: React.FC = () => {
    const currentDomain = getCurrentDomain()
    const actualHostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost'

    // Only show in development and when there's a test domain override
    if (process.env.NODE_ENV !== 'development' || currentDomain === actualHostname) {
        return null
    }

    return (
        <Group
            style={{
                position: 'fixed',
                top: '10px',
                right: '10px',
                zIndex: 9999,
                backgroundColor: 'rgba(255, 165, 0, 0.9)',
                padding: '8px 12px',
                borderRadius: '6px',
                border: '1px solid #ff8c00',
                fontSize: '12px',
                color: 'white',
                fontWeight: 600,
                backdropFilter: 'blur(4px)'
            }}
        >
            <Text size="xs">TEST: {currentDomain}</Text>
            <Badge size="xs" color="orange" variant="filled">
                DEV
            </Badge>
        </Group>
    )
} 